export enum UserProfiles {
    Master,
    EndUser,
    Admin,
    Service,
    Manager,
}

export enum Status {
    Disabled,
    Enabled,
    Deleted,
}

export enum Environment {
    Production = 1,
    Sandbox,
    Staging,
}

export enum FeatureKeys {
    FaceRecognition = 1,
    DocsClassification,
    TextInImage,
    SpeechToText,
    FraudDetection,
    SignatureMatch,
    SpeakerVerification,
    SpeakerIdentification,
    CompareTwoAudios,
    DriverLicense,
    Blacklist,
    Whitelist,
    Onboarding,
    Trial,
    Dashboard,
    Search,
    Flags,
    Certified,
    Watchlists,
    SilencedList,
    ManageUsers,
    InviteUsers,
    Webhooks,
    ApiTokens,
    Pricing,
    Logs,
    GeneralConfig,
    ManageProfiles,
    GeneralConfigCompany,
    GeneralConfigBiometrics,
    GeneralConfigAntifraud,
    GeneralConfigGenesys,
    WatchlistsPhones,
    WatchlistsVoices,
    WatchlistsConfig,
    ManageTemplates,
    SuccessfulOperationsReport,
    CertifiedBiometricsReport,
    DebugGenesys,
    Customers,
    ReportFlags,
    EndFlags,
    WatchlistsValidationReport,
    AllowlistValidationReport,
    ApiDocs,
    OauthLogin,
    CredibilityReport,
    CertificationMethod,
    SearchTimelineTab,
    SearchFraudNetwork,
    SearchVoiceMap,
    PhoneReport,
    GeneralConfigAntispoofing,
    SearchAuthorizedDevices,
    WatchlistAutomations,
    Cases,
    CasesOverview,
    CasesOccurrences,
    CasesHistory,
    CasesVoiceMap,
    CasesFraudMap,
    CasesJourney,
    CasesWatchlistHistory,
    CasesAudios,
    CasesFinish,
    CertifiedAuthenticationsReport,
    SearchGroupedByExternalId,
}

export enum AntispoofingTypes {
    ReplayAttack,
    SyntheticVoice,
}

export enum ModularProductTier {
    FraudShield = 1,
    MindsId,
}

export enum AntispoofingResults {
    Live = 'live',
    Spoof = 'spoof',
    Error = 'error',
}
